import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY } from 'app-constants'
import { Button } from 'components'
import './style.scss'

export function IneligibleStoreError() {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-ineligible-error'>
      <div className='container-info'>
        <div className='container-image'>
          <STATICS.INFO_OUTLINE />
        </div>
        <span className='title'>No momento não há ofertas disponíveis na Loja de Serviços</span>
        <span className='description'>Em breve, novas ofertas podem ser liberadas.</span>
      </div>
      <Button color='primary' onClick={handleClick} className='button'>
        <STATICS.BACK /> Voltar para home
      </Button>
    </div>
  )
}
